import * as R from 'ramda';

import {
    blendingActivated,
    checkIsAnalyticSource,
    isBlendableSource,
    mappingActivated,
} from '@/utils/dashboard';
import { WIDGET_TYPES } from '@/utils/consts';

const { PIVOT_TABLE_ANALYTIC, DATA_STERAM, AUTOMATION } = WIDGET_TYPES;

export const isNativeMarketingSource = R.complement(checkIsAnalyticSource);
export const isMarketingSource = R.anyPass([
    isNativeMarketingSource,
    mappingActivated,
]);
export const isMarketingLikeSource = R.anyPass([
    isMarketingSource,
    blendingActivated,
]);

export const requireDateSettingSource = R.pathEq(
    ['settings', 'requireDateSettings'],
    true
);

export const checkSourceItemEditable = (
    { gteEdit, widgetType, allowWorkspaceForBlendData },
    item
) => {
    if (!gteEdit || widgetType === AUTOMATION) return false;

    return Boolean(
        allowWorkspaceForBlendData &&
            isBlendableSource(item) &&
            ((widgetType !== PIVOT_TABLE_ANALYTIC &&
                widgetType !== DATA_STERAM) ||
                requireDateSettingSource(item))
    );
};
